// P1-1 (Beta Sprint 1) — mecanismo global único de sincronización de citas.
// Toda mutación exitosa de bookings emite este evento; toda superficie que
// muestre citas se suscribe y refetchea del backend (fuente de verdad).
export const BOOKING_EVENT = 'lineage_booking_updated';

export const emitBookingUpdated = (detail = {}) => {
  try {
    window.dispatchEvent(new CustomEvent(BOOKING_EVENT, { detail }));
  } catch { /* noop */ }
};

export const onBookingUpdated = (cb) => {
  window.addEventListener(BOOKING_EVENT, cb);
  return () => window.removeEventListener(BOOKING_EVENT, cb);
};

// Reconciliación al volver a la pestaña/dispositivo (multi-sesión).
export const onWindowRefocus = (cb) => {
  const onVis = () => { if (document.visibilityState === 'visible') cb(); };
  window.addEventListener('focus', cb);
  document.addEventListener('visibilitychange', onVis);
  return () => {
    window.removeEventListener('focus', cb);
    document.removeEventListener('visibilitychange', onVis);
  };
};
